export interface PlayerRatingChange {
  name?: string;
  ratingBefore?: number | null;
  ratingAfter?: number | null;
  ratingChange?: number | null;
  ratingNotCounted?: boolean;
}

export interface MatchPayload {
  matchIndex?: number;
  groupName?: string | null;
  isSingleMatch?: boolean;
  team1?: string[];
  team2?: string[];
  team1Ids?: number[];
  team2Ids?: number[];
  player1?: string;
  player2?: string;
  player1Id?: number;
  player2Id?: number;
  winner?: number;
  matchResult?: string | null;
  setScores?: string[];
  fractional?: boolean;
  fractionalPoints1?: number | null;
  fractionalPoints2?: number | null;
  team1RatingBefore?: number | null;
  team1RatingAfter?: number | null;
  team1RatingChange?: number | null;
  team2RatingBefore?: number | null;
  team2RatingAfter?: number | null;
  team2RatingChange?: number | null;
  player1RatingBefore?: number | null;
  player1RatingAfter?: number | null;
  player1RatingChange?: number | null;
  player2RatingBefore?: number | null;
  player2RatingAfter?: number | null;
  player2RatingChange?: number | null;
  playerRatingChanges?: Record<string, PlayerRatingChange>;
}

export type Discipline = "singiel" | "debel";

export const DISCIPLINE_ORDER: Discipline[] = ["singiel", "debel"];

export const DISCIPLINE_LABEL: Record<Discipline, string> = {
  singiel: "Singiel",
  debel: "Debel",
};

export function isDoublesMatch(match: MatchPayload): boolean {
  if (typeof match.isSingleMatch === "boolean") {
    return !match.isSingleMatch;
  }

  const team1 = Array.isArray(match.team1) ? match.team1 : [];
  const team2 = Array.isArray(match.team2) ? match.team2 : [];

  return team1.length > 1 || team2.length > 1;
}

export function splitByDiscipline(
  matches: MatchPayload[],
): Record<Discipline, MatchPayload[]> {
  return {
    singiel: matches.filter((match) => !isDoublesMatch(match)),
    debel: matches.filter(isDoublesMatch),
  };
}

export function playedDisciplines(matches: MatchPayload[]): Discipline[] {
  const byDiscipline = splitByDiscipline(matches);

  return DISCIPLINE_ORDER.filter((discipline) => byDiscipline[discipline].length > 0);
}
